import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  max-height: 250px;
  flex-grow: 1;
  padding: 0 15px 0 0;
  overflow: auto;
  border-top: ${props => !props.lastItem && props.theme.borderTop};

  &::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.thumb};
    border-radius: 9px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.track};
    border-radius: 9px;
  }
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
`;

export const Item = styled(RouterLink)`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  padding: ${props => props.theme.padding.default};
  transition: 0.2s all;
  cursor: pointer;
  border-bottom: ${props => !props.lastItem && props.theme.borderBottom};

  ${Media.lg`
    padding: ${props => props.theme.padding.lg};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
`;

export const ItemExternal = styled.a`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  padding: ${props => props.theme.padding.default};
  border: ${props => props.theme.border};
  transition: 0.2s all;
  cursor: pointer;
  border-bottom: ${props => !props.lastItem && props.theme.borderBottom};

  ${Media.lg`
    padding: ${props => props.theme.padding.lg};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Text = styled.h3`
  display: block;
  width: 100%;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:hover{
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
    `}
`;

export const Arrow = styled.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 5px;
  color: ${props => props.theme.color};
  vertical-align: middle;
  transition: 0.2s all;

  ${Item}:hover &,
  ${ItemExternal}:hover & {
    color: ${props => props.theme.colorOnHover};
  }
`;
